/**
 * CSS Variables
 *
 * Centralized CSS variable names built from global config.
 * Ensures consistency across all modules.
 *
 * Usage:
 *   import cssVariables from '@utils/cssVariables';
 *   const value = getComputedStyle(el).getPropertyValue(cssVariables.state);
 */

import config from '@config';

const globalCssVars = config._global.cssVars as {
  prefix: string;
  state: { name: string };
  clip?: { name: string };
};

const cssVariables = {
  prefix: globalCssVars.prefix,
  state: globalCssVars.prefix + globalCssVars.state.name,
  clip: globalCssVars.prefix + (globalCssVars.clip?.name || 'clip'),
};

export default cssVariables;
